import React, { memo } from "react"
import Markdown from "../common/markdown"
import SkImage from "../common/skImage"
import classNames from "classnames"

const AnswerCard = ({
  id,
  text,
  image,
  altImage = null,
  imageAltText,
  selected = false,
  onClick,
}) => {
  const className = classNames(
    "flex flex-col justify-around w-32 h-44 2k:w-48 2k:h-72 shadow-3xl rounded-md mx-2 my-3 cursor-pointer transform transition-transform",
    {
      "scale-105": selected,
    }
  )

  const imageClass = classNames("mx-auto", {
    "grayscale-contrast": !selected,
    "hidden-force ": altImage && !selected,
  })

  const altImageClass = classNames("mx-auto", {
    "hidden-force": selected,
  })

  return (
    <div onClick={onClick} className={className}>
      <div className="flex-1" />
      {text && !image && (
        <Markdown
          className="px-1 text-sm text-center select-none"
          markdown={text}
        />
      )}
      {image && (
        <div className="inline-block px-2 m-3">
          <SkImage
            image={image}
            alt={imageAltText}
            imgStyle={imageStyle}
            style={imageStyle}
            className={imageClass}
          />
          {altImage && (
            <SkImage
              image={altImage}
              alt={imageAltText}
              imgStyle={imageStyle}
              style={imageStyle}
              className={altImageClass}
            />
          )}
        </div>
      )}
      <div className="flex flex-1">
        {text && image && (
          <Markdown
            className="flex flex-1 px-1 text-sm text-center justify-center items-end pb-2 select-none"
            markdown={text}
          />
        )}
      </div>
    </div>
  )
}

const imageStyle = {
  width: "auto",
  maxHeight: "6rem",
  marginLeft: "auto",
  marginRight: "auto",
}

export default memo(AnswerCard)
